import { createContext, useState } from 'react';
import { Backdrop, CircularProgress } from '@mui/material';
import axios from 'axios';

const AppContext = createContext({
	backdropOpen: false,
	noticeOpen: false,
	resourceOpen: false,
	centralityIndexOpen: false,
	step: 1,
	mapMode: 'dual',
	GISSERVER_URL: `${process.env.REACT_APP_CONTEXT_PATH}/interactive`,
	CONTEXT_PATH: `${process.env.REACT_APP_CONTEXT_PATH}/interactive`,
});

const AppProvider = ({ children }) => {
	const [backdropOpen, setBackdropOpen] = useState(false);
	const [noticeOpen, setNoticeOpen] = useState(false);
	const [resourceOpen, setResourceOpen] = useState(false);
	const [centralityIndexOpen, setCentralityIndexOpen] = useState(false);

	const [mapMode, setMapMode] = useState('dual');
	const [step, setStep] = useState(1);

	const GISSERVER_URL = process.env.REACT_APP_GISSERVER_URL;
	const CONTEXT_PATH = `${process.env.REACT_APP_CONTEXT_PATH}/interactive`;

	const execFunctionLog = (funcNm, funcDesc) => {
		axios({
			method: 'POST',
			url:
				process.env.REACT_APP_CONTEXT_PATH +
				'/interactive/api/function/log.json?func_nm=' +
				funcNm +
				'&func_desc=' +
				funcDesc +
				'&item_cd=cen&item_nm=유입⋅유출 중심성 지수로 알아보는 우리 지역 거점',
		})
			.then(() => {})
			.catch((err) => {
				console.log('functionLog error', err);
			});
	};

	return (
		<AppContext.Provider
			value={{
				backdropOpen,
				noticeOpen,
				resourceOpen,
				centralityIndexOpen,
				step,
				mapMode,

				setBackdropOpen,
				setNoticeOpen,
				setResourceOpen,
				setCentralityIndexOpen,
				setStep,
				setMapMode,

				GISSERVER_URL,
				CONTEXT_PATH,

				execFunctionLog
			}}
		>
			{children}
			<Backdrop
				open={backdropOpen}
				xs={{ color: '#fff' }}
				style={{zIndex: 1}}
			>
				<CircularProgress color="inherit" />
			</Backdrop>
		</AppContext.Provider>
	);
};

export { AppContext, AppProvider };
